import {SupportedLocales} from '#types/locale.js';

export const experimentLeaderboardLanguage = {
  [SupportedLocales.EN]: {
    activePeriod: 'Audience experiments active in',
    allTime: 'All time',
    last30: 'Last 30 days',
    last90: 'Last 90 days',
    last365: 'Last 12 months',
    close: 'Close',
    openSource: 'Open experiment',
    comparison: 'Treatment vs. control',
    historyTitle: 'Cumulative lift over time',
    historyDescription: 'Stabilizes as the control group accrues outcomes',
    noHistory: 'Historical measurements are not available yet.',
    lift: 'Lift',
    statSig: 'StatSig',
    treated: 'treated',
    heldOut: 'held out',
    versus: 'vs',
    detailError: 'Could not load experiment details.',
    title: 'Experiment lift leaderboard',
    navigation: 'Lift',
    description:
      'Every experiment in the workspace, ranked by measured lift and organized by metric.',
    note: 'Latest available snapshots · Refreshed daily · Positions are not winner decisions',
    metric: 'Metric',
    allMetrics: 'All metrics',
    type: 'Type',
    allTypes: 'All types',
    audience: 'Audience',
    journey: 'Journey',
    descending: 'Descending',
    ascending: 'Ascending',
    rank: 'Rank',
    name: 'Experiment',
    relative: 'Lift %',
    absolute: 'Absolute lift',
    control: 'Control',
    treatment: 'Treatment',
    phase: 'Phase',
    size: 'Profiles',
    calculated: 'Last calculated',
    snapshot: 'Snapshot',
    unknownDate: 'Unknown',
    loading: 'Loading experiments…',
    error: 'Unable to load experiments.',
    retry: 'Try again',
    empty:
      'No experiments match these filters. New experiments appear after the daily sync.',
    missingMetric: 'No outcome metric configured',
    pending: 'Awaiting calculation',
    unsupported: 'No comparable two-arm lift',
    stale: 'Stale · showing last successful result',
    unknownCalculation: 'Calculation time unavailable',
    notStarted: 'Not started',
    running: 'Running',
    awaitingResult: 'Awaiting result',
    rollout: 'Rollout',
    postRollout: 'Post rollout',
    completed: 'Completed',
    points: 'pt',
    previous: 'Previous page',
    next: 'Next page',
    page: 'Page',
    of: 'of',
    experiments: 'experiments',
  },
  [SupportedLocales.ES]: {
    activePeriod: 'Experimentos de audiencia activos en',
    allTime: 'Todo el período',
    last30: 'Últimos 30 días',
    last90: 'Últimos 90 días',
    last365: 'Últimos 12 meses',
    close: 'Cerrar',
    openSource: 'Abrir experimento',
    comparison: 'Tratamiento frente a control',
    historyTitle: 'Incremento acumulado en el tiempo',
    historyDescription:
      'Se estabiliza a medida que el grupo de control acumula resultados',
    noHistory: 'Las mediciones históricas aún no están disponibles.',
    lift: 'Incremento',
    statSig: 'StatSig',
    treated: 'tratados',
    heldOut: 'en control',
    versus: 'frente a',
    detailError: 'No se pudieron cargar los detalles del experimento.',
    title: 'Clasificación del incremento de experimentos',
    navigation: 'Lift',
    description:
      'Todos los experimentos del espacio de trabajo, clasificados por incremento medido y organizados por métrica.',
    note: 'Últimas mediciones disponibles · Actualización diaria · Las posiciones no determinan ganadores',
    metric: 'Métrica',
    allMetrics: 'Todas las métricas',
    type: 'Tipo',
    allTypes: 'Todos los tipos',
    audience: 'Audiencia',
    journey: 'Recorrido',
    descending: 'Descendente',
    ascending: 'Ascendente',
    rank: 'Posición',
    name: 'Experimento',
    relative: 'Incremento %',
    absolute: 'Incremento absoluto',
    control: 'Control',
    treatment: 'Tratamiento',
    phase: 'Fase',
    size: 'Perfiles',
    calculated: 'Último cálculo',
    snapshot: 'Medición',
    unknownDate: 'Desconocida',
    loading: 'Cargando experimentos…',
    error: 'No se pudieron cargar los experimentos.',
    retry: 'Intentar de nuevo',
    empty:
      'Ningún experimento coincide con estos filtros. Los nuevos experimentos aparecen después de la sincronización diaria.',
    missingMetric: 'Sin métrica de resultado configurada',
    pending: 'Esperando cálculo',
    unsupported: 'Sin incremento comparable entre dos grupos',
    stale: 'Desactualizado · mostrando el último resultado correcto',
    unknownCalculation: 'Hora del cálculo no disponible',
    notStarted: 'No iniciado',
    running: 'En ejecución',
    awaitingResult: 'Esperando resultado',
    rollout: 'Despliegue',
    postRollout: 'Después del despliegue',
    completed: 'Completado',
    points: 'pt',
    previous: 'Página anterior',
    next: 'Página siguiente',
    page: 'Página',
    of: 'de',
    experiments: 'experimentos',
  },
};
